<mat-action-list class="no-padding">
  <pr-transaction-action-menu-button
    *ngFor="let action of actions$ | async; trackBy: trackByAction"
    [action]="action"
    [data]="data$ | async"
  />
</mat-action-list>
